// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"6eca7b61","555":"a324d251","564":"4f6f4920","787":"d16d0675","975":"28111f0f"}[chunkId] + ".chunk.js";
};